import React, { useEffect } from 'react';
import { trans } from '../../../_providers/Translation'

function BonusPolicy(props) {

    return (
        <table>
            <thead>
                <tr>
                    <th>{trans('tables.activity')}</th>
                    <th>{trans('tables.date')}</th>
                    <th>{trans('tables.employee')}</th>
                    
                    <th>{trans('tables.type_id')}</th>
                    <th>{trans('tables.from')}</th>
                    <th>{trans('tables.to')}</th>
                    <th>{trans('tables.super_reward')}</th>
                    <th>{trans('tables.super_reward_currency')}</th>
                </tr>
            </thead>
            <tbody>
                {props.data.map((h, i) => (
                    <tr key={i} className={[h.actual ? 'actual' : h.selected ? 'selected' : '']}>
                            <td>{h.event}</td>
                            <td>{h.date}</td>
                            <td>{h.causer ? `${h.causer.name} ${h.causer.lastname}` : '-'}</td>
                            <td>{h.subject?.type_id ?? '-'}</td>
                            <td>{h.subject?.from ?? '-'}</td>
                            <td>{h.subject?.to ?? '-'}</td>
                            <td>{h.subject?.super_reward ?? '-'}</td>
                            <td>{h.subject?.super_reward_currency ?? '-'}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default BonusPolicy;